<em-main>
  @if (saleReportObject$ | async; as saleReportObject) {
    <div class="justify-content-between layout--row">
      <h2 i18n>Rapport de vente</h2>
    </div>
    <div class="layout--column layout--gap-larger">
      <em-sale-reports-section
        [props]="[saleReportObject.currentSaleReport]"
        [readonly]="true"></em-sale-reports-section>
      @if (saleReportObject.associatedSaleReports && saleReportObject.associatedSaleReports.length > 0) {
        <em-sale-reports-section
          i18n-title
          title="Rapport associé"
          [props]="saleReportObject.associatedSaleReports"
          [readonly]="true"></em-sale-reports-section>
      }
    </div>
  }
</em-main>

<p-toast></p-toast>
